import { FoaPart, type SourcingEventDto } from "../../../autogen/bff-api";
import { eventIsDesignContest } from "../../sourcing-events/buyer/wizard/utils/designContest";

export const requiresStandstill = (event: SourcingEventDto): boolean => {
  if (eventIsDesignContest(event)) return false;
  if (event.standstillUnderDps) return false;
  if (event.choosesVoluntaryStandstill) return (event.award?.standstillDays ?? 0) > 0;
  const part = event.eventContext.type === "Public" ? event.eventContext.foaPart : null;
  return part === FoaPart.PartIii || part === FoaPart.PartIv || (event.buyerSetsStandstill ?? false);
};
